import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import './ErrorBoundary.css';
import Header from "../header/Header";

export default class ErrorBoundary extends Component {

    static propTypes = {
        children: PropTypes.node,
    };

    state = {
        error: null,
        errorInfo: null,
    };

    componentDidCatch(error, errorInfo) {
        this.setState({
            error,
            errorInfo,
        });
    }

    render() {
        if (this.state.errorInfo) {
            console.group("Error Boundary!!");
            console.log(this.state.error && this.state.error.toString());
            console.log(this.state.errorInfo.componentStack);
            console.groupEnd();
            return (
                <Fragment>
                    <Header/>
                    <div className="header__padding"/>
                    <div className="error__wrap">
                        <h2>You're not in Kansas anymore... </h2>
                        <h2>Clear cookies, then hit refresh to sign in again.</h2>
                        <br/>
                        <div className="errorBoundaryBg"/>
                    </div>
                </Fragment>
            );
        }

        return this.props.children;
    }
}
